import styled from "styled-components";

export const ChangePasswordContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
export const ShowPassword = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  div {
    cursor: pointer;
    display: flex;
    align-items: center;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #000;
    }
  }
`;
export const ButtonContainer = styled.div`
  padding: 10px 40px;
`;
